import React, { FC, useState, createContext, ReactNode, useEffect } from 'react';
type LoadingAnimationContext = {
    setShowLoading: (showLoading: boolean) => void;
};

type LoadingAnimationContextProps = {
    children: ReactNode;
};

export const LoadingAnimationContext = createContext<LoadingAnimationContext>(
    {} as LoadingAnimationContext
);

export const LoadingAnimationProvider = (props: LoadingAnimationContextProps) => {
    const [showLoading, setShowLoading] = useState(false);
    const ele: any = document.getElementById('page-loading');

    useEffect(() => {
        showLoading ? ele.classList.remove('d-none') : ele.classList.add('d-none');
    }, [showLoading]);

    return (
        <LoadingAnimationContext.Provider value={{ setShowLoading }}>
            {props.children}
        </LoadingAnimationContext.Provider>
    );
};
